const apiBase = (process.env.VUE_APP_APIENDPOINT || '').replace(/\/+$/, '')

export default {
  loginEndpoint: apiBase ? `${apiBase}/auth/login` : '/auth/login',
  registerEndpoint: apiBase ? `${apiBase}/auth/register` : '/auth/register',
  forgotPasswordEndpoint: apiBase ? `${apiBase}/auth/forgot-password` : '/auth/forgot-password',
  verifyForgotPasswordOtpEndpoint: apiBase ? `${apiBase}/auth/verify-forgot-password-otp` : '/auth/verify-forgot-password-otp',
  sendMobileOtpEndpoint: apiBase ? `${apiBase}/auth/send-mobile-otp` : '/auth/send-mobile-otp',
  verifyMobileOtpEndpoint: apiBase ? `${apiBase}/auth/verify-mobile-otp` : '/auth/verify-mobile-otp',
  sendEmailOtpEndpoint: apiBase ? `${apiBase}/auth/send-email-otp` : '/auth/send-email-otp',
  verifyEmailOtpEndpoint: apiBase ? `${apiBase}/auth/verify-email-otp` : '/auth/verify-email-otp',
  resetPasswordEndpoint: apiBase ? `${apiBase}/auth/reset-password` : '/auth/reset-password',
  refreshEndpoint: apiBase ? `${apiBase}/auth/refresh` : '/auth/refresh',
  logoutEndpoint: apiBase ? `${apiBase}/auth/logout` : '/auth/logout',

  tokenType: 'Bearer',
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
